import { listAll } from './listAll'
import { listPayments } from './listPayments'
import { listTransaction } from './listTransaction'
import { recharge } from './recharge'
import { transaction } from './transaction'

export default {
  ...listAll,
  ...listTransaction,
  ...listPayments,
  ...recharge,
  ...transaction
}
